import ChapterNavigator from "components/chapter-navigator/chapter-navigator";
import chapter1 from "assets/story/chapter-1";

const Story = () => {
    return (
        <ChapterNavigator chapter={chapter1}/>
    )
}

export default Story;